<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { authStore } from "@/auth/authStore";
import StatusPill from "./StatusPill.vue";

const router = useRouter();

// Sticky bar only renders while there's a current-user job in flight.
const job = computed(() => authStore.runningJobs.value[0] ?? null);

function go() {
  if (!job.value) return;
  router.push(`/playgrounds/${job.value.customer}`);
}
</script>

<template>
  <div
    v-if="job"
    class="fixed bottom-0 left-0 right-0 z-30 border-t border-border bg-bg/95 backdrop-blur dark:border-border-dark dark:bg-bg-dark/95"
    role="status"
  >
    <div class="mx-auto flex max-w-7xl items-center gap-4 px-6 py-2 text-sm">
      <span class="mono text-fg dark:text-fg-dark">{{ job.customer }}</span>
      <StatusPill :status="job.status" />
      <span
        v-if="job.step != null && job.totalSteps != null"
        class="text-2xs text-fg-muted"
      >step {{ job.step }}/{{ job.totalSteps }}</span>
      <span class="flex-1" />
      <button
        type="button"
        class="text-2xs text-accent hover:underline dark:text-accent-dark"
        @click="go"
      >view &rarr;</button>
    </div>
  </div>
</template>
